import Leaflet from "leaflet";

export default function Map() {
  Alpine.data("map", () => ({
    mapInstance: null,
    activeMarker: null,

    init() {
      requestAnimationFrame(() => {
        this.createMap();
      });
    },

    createMap() {
      this.mapInstance = Leaflet.map(this.$refs.mapEl, {
        attributionControl: false,
        minZoom: 3,
        maxZoom: 5,
        scrollWheelZoom: false,
        zoomControl: false,
        maxBounds: [
          [-90, -180],
          [90, 180],
        ],
        maxBoundsViscosity: 1.0,
      }).setView([20, 0], 2);

      Leaflet.control
        .zoom({
          position: "bottomright",
        })
        .addTo(this.mapInstance);

      Leaflet.tileLayer(
        "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
      ).addTo(this.mapInstance);

      this.addMarkers();
    },

    addMarkers() {
      const markers = JSON.parse(this.$root.dataset.markers || "[]");

      const icon = Leaflet.divIcon({
        className: "",
        html: `<div style="width:20px;height:20px;border-radius:50%;background:#22c55e;border:3px solid white;box-shadow:0 0 0 2px #22c55e;"></div>`,
        iconSize: [20, 20],
        iconAnchor: [10, 10],
      });

      markers.forEach((marker) => {
        const m = Leaflet.marker([marker.lat, marker.lng], { icon }).addTo(
          this.mapInstance,
        );

        m.bindTooltip(marker.title, {
          permanent: false,
          direction: "right",
          offset: [12, 0],
          className: "map-tooltip",
        });

        m.on("click", () => {
          this.activeMarker = marker;
          this.$nextTick(() => {
            this.mapInstance.invalidateSize();
          });
        });
      });
    },
  }));
}
